/* eslint-disable @typescript-eslint/no-unused-vars */
export function removeMetaFields(data: any) {
  const {
    id,
    is_active,
    created_on,
    updated_on,
    created_by_id,
    updated_by_id,
    created_by,
    updated_by,
    ...filteredData
  } = data;

  return filteredData;
}
